import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  return <div className="mx-auto w-full max-w-xl rounded-2xl border border-alert/40 bg-alert/10 p-4" role="timer" aria-live="off" data-id="element-18" data-mp="3c25tpgmxsc38">
      <p className="mb-3 flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wide text-red-300" data-id="element-19" data-mp="3h20f54ny09gw">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="325szmhnhbw7y" />
        Launch price ends in
      </p>
      <div className="flex items-start justify-center gap-2 sm:gap-3" data-id="element-21" data-mp="374vsl3q6qbzk">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-22" data-mp="10a8ru14hflur" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="15bofm0y1o6gu">
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-ink-950 font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-24" data-mp="159bwvlkgps2q">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-300" data-id="element-25" data-mp="17py9r9bu29xe">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-3 font-display text-3xl font-black text-red-300 sm:pt-4" data-id="element-26" data-mp="f2aort6nhha8">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}